import React, { Component } from 'react';
import PropTypes from 'prop-types';
import colors from '../../config/colors';
import { requiredField } from '../../lib/form-input-validators';
import FormInput from '../../components/FormInput';
import './styles.scss';

const fieldStyles = {
  mainContainer: {
    boxSizing: 'border-box',
    width: '100%',
  },
  labelContainer: {
    boxSizing: 'border-box',
    display: 'block',
    height: 'auto',
    marginBottom: 6,
    width: '100%',
  },
  label: {
    color: colors.grays.light,
    fontSize: '0.8rem',
    fontWeight: 500,
    position: 'static',
    transform: 'none',
  },
  fieldContainer: {
    boxSizing: 'border-box',
    display: 'block',
    width: '100%',
  },
  input: {
    backgroundColor: colors.white,
    border: `1px solid ${colors.dagny.line}`,
    borderRadius: 4,
    boxSizing: 'border-box',
    color: colors.text,
    fontSize: '0.9rem',
    height: 34,
    padding: '0 11px',
    width: '100%',
  },
  validationContainer: {
    boxSizing: 'border-box',
    color: colors.dagny.error,
    fontSize: '0.78rem',
    minHeight: 16,
    paddingTop: 3,
  },
};

const { bool, object, func } = PropTypes;

export default class SupplierBasicInformationForm extends Component {

  static propTypes = {
    initialValues: object.isRequired,
    onSubmit: func.isRequired,
    triggerSubmit: bool.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      formValues: {
        ...props.initialValues,
      },
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.triggerSubmit) {
      this.props.onSubmit(this.state.formValues);
    }
  }

  handleInputChange = (event) => {
    const { target } = event;
    const { value } = target;
    this.setState({
      ...this.state,
      formValues: {
        ...this.state.formValues,
        [target.name]: value,
      },
    });
  }

  render() {
    const { formValues } = this.state;
    return (
      <form className="supplier-form" onSubmit={event => event.preventDefault()}>
        <section className="supplier-form__section supplier-form__section--organisation">
          <header className="supplier-section__header">
            <h3 className="supplier-section__title">Organisation</h3>
            <p className="supplier-section__description">
              Supplier identity, phone number, and priority tier.
            </p>
          </header>
          <div className="supplier-form__grid">
            <div className="supplier-form__field--wide">
              <FormInput
                label="Company name"
                name="companyName"
                onChange={this.handleInputChange}
                placeholder="Enter the registered company name"
                styles={fieldStyles}
                type="text"
                validate={requiredField}
                validateOnMount={false}
                value={formValues.companyName}
              />
            </div>
            <FormInput
              label="Main phone"
              name="mainTelephone"
              onChange={this.handleInputChange}
              placeholder="Enter a phone number"
              styles={fieldStyles}
              type="text"
              validate={requiredField}
              validateOnMount={false}
              value={formValues.mainTelephone}
            />
            <FormInput
              label="Tier"
              name="tier"
              onChange={this.handleInputChange}
              placeholder="For example, 0 or 1"
              styles={fieldStyles}
              type="text"
              validate={requiredField}
              validateOnMount={false}
              value={formValues.tier}
            />
          </div>
        </section>

        <section className="supplier-form__section supplier-form__section--address">
          <header className="supplier-section__header">
            <h3 className="supplier-section__title">Address</h3>
            <p className="supplier-section__description">
              Registered or primary business address.
            </p>
          </header>
          <div className="supplier-form__grid supplier-form__grid--address">
            <div className="supplier-form__field--wide">
              <FormInput
                label="Address line 1"
                name="address1"
                onChange={this.handleInputChange}
                placeholder="Building and street"
                styles={fieldStyles}
                type="text"
                validate={requiredField}
                validateOnMount={false}
                value={formValues.address1}
              />
            </div>
            <div className="supplier-form__field--wide">
              <FormInput
                label="Address line 2"
                name="address2"
                onChange={this.handleInputChange}
                placeholder="Additional address information"
                styles={fieldStyles}
                type="text"
                validate={requiredField}
                validateOnMount={false}
                value={formValues.address2}
              />
            </div>
            <FormInput
              label="City"
              name="city"
              onChange={this.handleInputChange}
              placeholder="City"
              styles={fieldStyles}
              type="text"
              validate={requiredField}
              validateOnMount={false}
              value={formValues.city}
            />
            <FormInput
              label="County"
              name="county"
              onChange={this.handleInputChange}
              placeholder="County"
              styles={fieldStyles}
              type="text"
              validate={requiredField}
              validateOnMount={false}
              value={formValues.county}
            />
            <FormInput
              label="Postcode"
              name="postcode"
              onChange={this.handleInputChange}
              placeholder="Postcode"
              styles={fieldStyles}
              type="text"
              validate={requiredField}
              validateOnMount={false}
              value={formValues.postcode}
            />
          </div>
        </section>

        <section className="supplier-form__section supplier-form__section--registration">
          <header className="supplier-section__header">
            <h3 className="supplier-section__title">Registration and brand</h3>
            <p className="supplier-section__description">
              Business identifiers and an optional hosted supplier logo URL.
            </p>
          </header>
          <div className="supplier-form__grid">
            <FormInput
              label="Company number"
              name="companyNumber"
              onChange={this.handleInputChange}
              placeholder="Registered company number"
              styles={fieldStyles}
              type="text"
              validate={requiredField}
              validateOnMount={false}
              value={formValues.companyNumber}
            />
            <FormInput
              label="VAT number"
              name="vatNumber"
              onChange={this.handleInputChange}
              placeholder="VAT registration number"
              styles={fieldStyles}
              type="text"
              validate={requiredField}
              validateOnMount={false}
              value={formValues.vatNumber}
            />
            <div className="supplier-form__field--wide">
              <FormInput
                label="Logo URL (optional)"
                name="logoUrl"
                onChange={this.handleInputChange}
                placeholder="https://"
                styles={fieldStyles}
                type="text"
                value={formValues.logoUrl}
              />
            </div>
          </div>
        </section>
      </form>
    );
  }
}
